import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../config/config";
import { toast } from "react-toastify";

const dict = {
  en: {
    forgotPassword: "Forgot Password",
    email: "Email Address",
    sendLink: "Send Reset Link",
    backToLogin: "Back to Login",
    loading: "Sending...",
    successMessage: "If your email is registered, a reset link has been sent.",
    errorMessage: "An error occurred. Please try again.",
    emailPlaceholder: "Enter your registered email",
  },
  ar: {
    forgotPassword: "نسيت كلمة المرور",
    email: "البريد الإلكتروني",
    sendLink: "إرسال رابط إعادة التعيين",
    backToLogin: "العودة إلى تسجيل الدخول",
    loading: "جاري الإرسال...",
    successMessage: "إذا كان بريدك الإلكتروني مسجلاً لدينا، فقد تم إرسال رابط إعادة التعيين.",
    errorMessage: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    emailPlaceholder: "أدخل بريدك الإلكتروني المسجل",
  }
};

export default function ForgotPassword({ lang }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isAr = lang?.Lang === "ar" || localStorage.getItem("AC-lang") === "ar";
  const t = isAr ? dict.ar : dict.en;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    axios
      .post(`${apiKey}/forgot-password`, { email })
      .then((res) => {
        toast.success(t.successMessage);
        setEmail("");
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.response?.data?.Error || t.errorMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh", backgroundColor: "#f8fafc" }}
      dir={isAr ? "rtl" : "ltr"}
    >
      <div
        className="card shadow-lg p-5 border-0"
        style={{
          width: "100%",
          maxWidth: "450px",
          borderRadius: "16px",
          backgroundColor: "#ffffff",
        }}
      >
        <div className="text-center mb-4">
          <div className="mb-3 d-inline-block p-3 rounded-circle" style={{ backgroundColor: "#eff6ff" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="#3b82f6"
              viewBox="0 0 16 16"
            >
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
            </svg>
          </div>
          <h2 className="font-weight-bold text-dark" style={{ fontSize: "1.6rem" }}>
            {t.forgotPassword}
          </h2>
          <p className="text-muted mt-2" style={{ fontSize: "0.9rem", lineHeight: "1.4" }}>
            {isAr
              ? "أدخل بريدك الإلكتروني المسجل وسنقوم بإرسال رابط لإعادة تعيين كلمة المرور."
              : "Enter your email address and we will send you a secure link to reset your password."}
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group mb-4">
            <label className="text-secondary font-weight-bold mb-2" style={{ fontSize: "0.85rem" }}>
              {t.email}
            </label>
            <input
              type="email"
              className="form-control form-control-lg"
              placeholder={t.emailPlaceholder}
              style={{
                borderRadius: "10px",
                border: "1.5px solid #cbd5e1",
                fontSize: "1rem",
                padding: "12px 16px",
              }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg w-100 font-weight-bold py-3 mb-3"
            style={{
              borderRadius: "10px",
              fontSize: "1rem",
              background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
              border: "none",
              transition: "transform 0.2s ease",
            }}
            disabled={loading}
          >
            {loading ? t.loading : t.sendLink}
          </button>

          <div className="text-center mt-3">
            <button
              type="button"
              className="btn btn-link text-decoration-none font-weight-bold"
              style={{ fontSize: "0.9rem", color: "#3b82f6" }}
              onClick={() => navigate("/")}
              disabled={loading}
            >
              {t.backToLogin}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
